var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "tableContainer",
      staticStyle: {
        padding: "8px",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      },
      style: _vm.bg_class,
    },
    [
      _c(
        "el-row",
        { staticStyle: { height: "100%" } },
        [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.title_show,
                  expression: "title_show",
                },
              ],
              ref: "title",
              style: _vm.title_class,
            },
            [_vm._v(_vm._s(_vm.chart.title))]
          ),
          _c(
            "ux-grid",
            {
              ref: "plxTable",
              staticClass: "table-class",
              class: _vm.chart.id,
              style: _vm.tableStyle,
              attrs: {
                size: "mini",
                height: _vm.height,
                "checkbox-config": { highlight: true },
                "width-resize": true,
                "header-row-style": _vm.table_header_class,
                "row-style": _vm.getRowStyle,
                "merge-cells": _vm.mergeCells,
                "show-summary": _vm.showSummary,
                "summary-method": _vm.summaryMethod,
                "index-config": { seqMethod: _vm.seqMethod },
              },
            },
            [
              _c("ux-table-column", {
                attrs: { type: "index", title: _vm.indexLabel },
              }),
              _vm._l(_vm.fields, function (field) {
                return _c(
                  "ux-table-column",
                  {
                    key: field.name,
                    attrs: {
                      field: field.child ? "" : field.dataeaseName,
                      resizable: true,
                      sortable:
                        (!_vm.mergeCells || !_vm.mergeCells.length) &&
                        (!field.child || !field.child.length),
                      title: field.name,
                      width: _vm.columnWidth,
                    },
                  },
                  _vm._l(field.child, function (item) {
                    return _c("ux-table-column", {
                      key: field.name + item.name,
                      attrs: {
                        field: item.dataeaseName,
                        title: item.name,
                        width: _vm.columnWidth,
                      },
                    })
                  }),
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPage,
                  expression: "showPage",
                },
              ],
              staticClass: "table-page",
            },
            [
              _c(
                "el-row",
                { staticStyle: { position: "relative", width: "100%" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "table-page-inner", style: _vm.autoStyle },
                    [
                      _c(
                        "span",
                        { staticClass: "total-style", style: _vm.totalStyle },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("chart.total")) +
                              "\n            "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.chart.datasetMode === 0 &&
                                  !_vm.not_support_page_dataset.includes(
                                    _vm.chart.datasourceType
                                  )
                                  ? _vm.chart.totalItems
                                  : _vm.chart.data && _vm.chart.data.tableRow
                                  ? _vm.chart.data.tableRow.length
                                  : 0
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("chart.items")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("de-pagination", {
                        staticClass: "page-style",
                        attrs: {
                          small: "",
                          "current-page": _vm.currentPage.page,
                          "page-size": _vm.currentPage.pageSize,
                          "pager-count": 5,
                          "custom-style": {
                            color: _vm.title_class.color,
                          },
                          layout: "prev, pager, next",
                          total: _vm.currentPage.show,
                        },
                        on: {
                          "current-change": _vm.pageClick,
                          "size-change": _vm.pageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }